import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettings } from '../enums/app-settings.enum';
import { ErrorCodesConfigurations } from '../models/ErrorCodesConfigurations';

@Injectable({
  providedIn: 'root'
})
export class ApplicationErrorCodesInitializationService {
  errorCodesConfig: ErrorCodesConfigurations;

  constructor(private http: HttpClient) { }

  errorCodeInitialization() {
      return this.http.get(environment?.B2C_URL + '/getErrorCodeDescriptions.service').toPromise()
          .then(async (response: any) => {
              this.errorCodesConfig = response?.B2C_ERROR_CODES;
          })
          .catch((error) => {
              // When service fails, get the configurations from the backup
              this.prepareConfigurationBackup();

          });
  }

  prepareConfigurationBackup() {
      this.errorCodesConfig = new ErrorCodesConfigurations();   
      this.errorCodesConfig.B2C_ERROR_CODES = {"0":{"ar":"\u0639\u0630\u0631\u0627 ,\u0644\u0642\u062F \u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627 , \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u0627","en":"Sorry, something went wrong. Please try again later."}};
         

  }
}
